import constant from '../../store/constant'
var utils = require('../../utils')

export default {
  name: 'plan-edit',
  data: function () {
    return {
      enableList: {
        emergencyRels: false,
        emergency2Rels: false,
        sideEffectHistories: false,
        allergyHistories: false,
        bodyCharacters: false,
        complications: false,
        leadPlans1: false,
        leadPlans2: false,
        leadPlans3: false,
        leadPlans4: false,
        leadPlans5: false,
        leadPlans6: false
      },

      canValidate: false,  // true -> 実行
      showValidate:{ // true -> 警告表示
        shop_id: false,
        plan_date: false,
        creator_id: false,
        patient_name: false,
        sex: false,
        birthday: false,
        clinic_id: false,
        doctor_id: false,
        careman_id: false,
        facility_id: false,
        tel: false,
        post_no: false,
        address1: false,
        address2: false,
        emergency: false,
        emergency2: false,
        emergency_post_no: false,
        visit_interval: false,
        diseases: false,
        patient_name_furigana: false
      },

      // 計画書
      plan: {
        plan_id: null,
        patient_id: null,
        facility_id: null,
        plan_date: utils.getDate2Str(new Date()),
        // plan_ym: null,
        // plan_ym_last: null,
        shop_id: null,
        creator_id: null,
        clinic_id: null,
        doctor_id: null,
        careoffice_id: null,
        careman_id: null,
        post_no: null,
        address1: null,
        address2: null,
        tel: null,
        emergency_name: null,
        emergency_rel: null,
        emergency_tel: null,
        emergency2_name: null,
        emergency2_rel: null,
        emergency2_tel: null,
        emergency_post_no: null,
        emergency_address1: null,
        emergency_address2: null,
        pay_method: constant.pay_method.cach,
        side_effect_history: null,
        allergy_history: null,
        visit_interval: null,
        visit_weekday: 0,
        visit_plan: null,
        body_character: null,
        complication: null,
        lead_plan1: this.$t('plan.lead_plan1_default'),
        lead_plan2: this.$t('plan.lead_plan2_default'),
        lead_plan3: null,
        lead_plan4: null,
        lead_plan5: null,
        lead_plan6: null,
        special_comment: null,
        meeting_comment: null,
        other_disease_name: null,
        room_no: null,
        // create_time: null,
        // update_time: null,
        // del_flag: null,

        patient_name: null,
        patient_name_furigana: null,
        patient_code: null,
        sex: null,
        birthday: null,

        disease_ids: [],
        patient_avartar: null,
        patient_avartar_cache: null,
        patient_avartar_cache_path: null,

        facility_name: null,
        shop_name: null,
        creator_name: null,
        clinic_name: null,
        doctor_name: null,
        careoffice_name: null,
        careman_name: null,

        is_latest: null,
        can_save_next_plan: null,
        enable_flag: null,
        patient_enable: null,
        ns_patient_code: null
      },
      planBackup: {},
      utils: utils,

      // 正常入力値保持用
      ac: {
        facility_name: null,
        creator_name: null,
        clinic_name: null,
        doctor_name: null,
        careoffice_name: null,
        careman_name: null
      },

      // 確認ダイアログ用
      confirmYesNo: false,
      confirmTitle: this.$t('plan.confirm_title'),
      confirmMessage: '',
      confirmOnYes: () => {},
      confirmOnNo: () => {},
      confirmOnSave: () => {},
      confirmOnNotSave: () => {},
      confirmOnCancel: () => {},
      phraseCallbackFlag: false,
      searchCallbackFlag: false,
      isDetailFlag: false,
      isTypeFlag: false,
      isOutpatientFlag : false,
      isNsipsFlag : false,
    }
  },

  /** 画面遷移時 */
  beforeRouteLeave (to, from, next) {
    // オートコンプリートイベント削除
    utils.autocompleteEventRemove({$: $, elem:'#creator_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#clinic_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#doctor_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#careoffice_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#careman_name_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#facility_name_autocomplete'})

    utils.autocompleteEventRemove({$: $, elem:'#side_effect_history_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#allergy_history_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#emergency_rels_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#emergency2_rels_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#body_character_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#complication_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#lead_plan1_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#lead_plan2_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#lead_plan3_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#lead_plan4_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#lead_plan5_autocomplete'})
    utils.autocompleteEventRemove({$: $, elem:'#lead_plan6_autocomplete'})
    next()
  },

  created: function() {
    this.phraseCallbackFlag = false
    var self = this
    var callback = function () {
      self.phraseCallbackFlag = true
    }
    this.clearAllList()
    // this.$store.dispatch('SHOP_SEARCH')
    this.$store.dispatch('SHOP_SEARCH', {data: {all_get: true}, 'allShopName': this._self.$t('AllShopName'), callback: () => {}})
    this.$store.dispatch('PHRASE_CLEAR')
    this.$store.dispatch('PHRASE_SEARCH', {callback: callback})

    // 詳細画面からの遷移
    if ('facilityId' in this.$route.params && 'patientId' in this.$route.params && 'planId' in this.$route.params) {
      this.isDetailFlag = true
      if (this.$route.name == 'PlanCreate') {
        this.isTypeFlag = true
      }

    }

    // 外来患者からの遷移
    if ('outpatientId' in this.$route.params) {
      this.isOutpatientFlag = true
    }

    if ('planId' in this.$route.params) {
      // 編集
      this.$store.dispatch('USER_ADMIN_PHARMACIST') // システム管理者 または 薬剤師
      this.showPlan(this.$route.params.planId)
    } else if (this.isOutpatientFlag) {
      // 外来患者から新規在宅患者登録
      this.$store.dispatch('USER_ADMIN_PHARMACIST') // システム管理者 または 薬剤師
      this.showOutpatient(this.$route.params.outpatientId)
      this.searchCallbackFlag = true
    } else {
      // 新規作成
      var self = this
      var callbackPharmacist = function () {
        // if (!self.plan.creator_id && self.isAdminOrPharmacist) {
        if (self.isAdminOrPharmacist) {
          self.plan.creator_id    = self.userAdminOrPharmacistId
          self.plan.creator_name  = self.userAdminOrPharmacistName
          self.ac.creator_name    = self.userAdminOrPharmacistName
        }
        self.planBackup = utils.clone(self.plan)
        self.searchCallbackFlag = true
      }
      // システム管理者 または 薬剤師
      this.$store.dispatch('USER_ADMIN_PHARMACIST', {callback: callbackPharmacist})
    }
    if (this.$store.getters.canManage) {
      this.plan.shop_id = this.$store.getters.currentShopId
    }
    this.planBackup = utils.clone(this.plan)
    this.canValidate = true // 最初からValidateする
    Object.keys(this.showValidate).forEach(key => { this.showValidate[key] = true; }) // 最初から警告表示する

    // オートコンプリートイベント
    utils.autocompleteEvent({$:$, elem:'#creator_name_autocomplete',    search:() => {}, searchParams:false, searchAutocomplete:this.getCreators,    setSearchData:this.setSearchCreator,   clear: this.clearCreators})
    utils.autocompleteEvent({$:$, elem:'#clinic_name_autocomplete',     search:() => {}, searchParams:false, searchAutocomplete:this.getClinics,     setSearchData:this.setSearchClinic,    clear: this.clearClinics})
    utils.autocompleteEvent({$:$, elem:'#doctor_name_autocomplete',     search:() => {}, searchParams:false, searchAutocomplete:this.getDoctors,     setSearchData:this.setSearchDoctor,    clear: this.clearDoctors})
    utils.autocompleteEvent({$:$, elem:'#careoffice_name_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:this.getCareOffices, setSearchData:this.setSearchCareOffice,clear: this.clearCareOffices})
    utils.autocompleteEvent({$:$, elem:'#careman_name_autocomplete',    search:() => {}, searchParams:false, searchAutocomplete:this.getCaremans,    setSearchData:this.setSearchCareman,   clear: this.clearCaremans})
    utils.autocompleteEvent({$:$, elem:'#facility_name_autocomplete',   search:() => {}, searchParams:false, searchAutocomplete:this.getFacilities,  setSearchData:this.setSearchFacility,  clear: this.clearFacilities})

    utils.autocompleteEvent({$:$, elem:'#side_effect_history_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setSideEffectHistories})
    utils.autocompleteEvent({$:$, elem:'#allergy_history_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setAllergyHistories})
    utils.autocompleteEvent({$:$, elem:'#emergency_rels_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setEmergencyRels})
    utils.autocompleteEvent({$:$, elem:'#emergency2_rels_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setEmergency2Rels})
    utils.autocompleteEvent({$:$, elem:'#body_character_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setBodyCharacters})
    utils.autocompleteEvent({$:$, elem:'#complication_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setComplications})
    utils.autocompleteEvent({$:$, elem:'#lead_plan1_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setLeadPlans1})
    utils.autocompleteEvent({$:$, elem:'#lead_plan2_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setLeadPlans2})
    utils.autocompleteEvent({$:$, elem:'#lead_plan3_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setLeadPlans3})
    utils.autocompleteEvent({$:$, elem:'#lead_plan4_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setLeadPlans4})
    utils.autocompleteEvent({$:$, elem:'#lead_plan5_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setLeadPlans5})
    utils.autocompleteEvent({$:$, elem:'#lead_plan6_autocomplete', search:() => {}, searchParams:false, searchAutocomplete:() => {}, setSearchData:this.setLeadPlans6})

    // NSIPS 患者コード
    if(this.$router.currentRoute.query.nsips == 'patient'){
      this.isNsipsFlag = true
      if (utils.isPresent(this.$router.currentRoute.query.patient_code)) {
        var self = this
        this.plan.shop_id = this.$router.currentRoute.query.shop_id
        var callback = function () {
          self.plan.ns_patient_code = self.nsPatient.attributes['patient-code']
          self.plan.patient_name = self.nsPatient.attributes['patient-name']
          self.plan.sex = self.nsPatient.attributes['gender']
          self.plan.birthday = self.nsPatient.attributes['birthday']
        }
        this.$store.dispatch('NS_PATIENT_SEARCH', {
          data: { patient_code: this.$router.currentRoute.query.patient_code, shop_id: this.$router.currentRoute.query.shop_id },
          callback: callback
        })
      }
    }
  },

  computed: {
    authToken() {
      return window.localStorage.getItem('access_token')
    },
    notify() {
      return this.$store.getters.planNotify
    },
    shops () {
      return this.$store.getters.shops.filter((o) => {return o.id != null}) // 全店舗は不可
    },
    creators () {
      return this.$store.getters.usersAutocomplete
    },
    /** システム管理者 または 薬剤師 */
    isAdminOrPharmacist() {
      return this.$store.getters.userAdminOrPharmacist
    },
    /** システム管理者 または 薬剤師 ユーザーID */
    userAdminOrPharmacistId() {
      return this.$store.getters.userAdminOrPharmacistId
    },
    /** システム管理者 または 薬剤師 ユーザー名 */
    userAdminOrPharmacistName() {
      return this.$store.getters.userAdminOrPharmacistName
    },
    facilities () {
      var none = [{id: this.$t('none_list.id'), attributes: {'facility-name': this.$t('none_list.name')}}]
      var list = this.$store.getters.facilitiesAutocomplete
      return (list && list.length > 0) ? none.concat(list) : null
    },
    isFacility () {
      return this.$store.getters.isFacility
    },
    careOffices () {
      return this.$store.getters.careOfficesAutocomplete
    },
    clinics () {
      return this.$store.getters.clinicsAutocomplete
    },
    doctors () {
      return this.$store.getters.doctorsAutocomplete
    },
    caremans () {
      return this.$store.getters.caremansAutocomplete
    },

    emergencyRels () {
      return this.$store.getters.phrases[constant.phraseType.EMERGENCY_REL]
    },
    payMethods () {
      return this.$store.getters.phrases[constant.phraseType.PAY_METHOD]
    },
    sideEffectHistories () {
      return this.$store.getters.phrases[constant.phraseType.SIDE_EFFECT_HISTORY]
    },
    allergyHistories () {
      return this.$store.getters.phrases[constant.phraseType.ALLERGY_HISTORY]
    },
    visitIntervals () {
      var arr = [{id: null, attributes: {'phrase-type-id': null, 'phrase-code': null, 'phrase': ''}}]
      Array.prototype.push.apply(arr, this.$store.getters.phrases[constant.phraseType.VISIT_INTERVAL]);
      return arr
    },
    bodyCharacters () {
      return this.$store.getters.phrases[constant.phraseType.BODY_CHARACTER]
    },
    complications () {
      return this.$store.getters.phrases[constant.phraseType.COMPLICATION]
    },
    diseases() {
      return this.$store.getters.phrases[constant.phraseType.DISEASE]
    },
    leadPlans() {
      return this.$store.getters.phrases[constant.phraseType.LEAD_PLAN]
    },

    uploadCounter () {
      return this.$store.getters.avatarUploadCounter
    },
    uploadErrors () {
      return this.$store.getters.avatarUploadErrors
    },
    uploadSuccess () {
      return this.$store.getters.avatarUploadStatus
    },

    /** 各日付 (和暦) */
    planDate: {
      get: function () {return this.getWareki(this.plan.plan_date)},
      set: function (v) {this.plan.plan_date = this.getSeireki(v)}
    },
    birthday: {
      get: function () {return this.getWareki(this.plan.birthday)},
      set: function (v) {this.plan.birthday = this.getSeireki(v)}
    },
    defaultBirthday: function () {
      var d = new Date()
      d.setYear(d.getFullYear()-80)
      return d
    },

    /** バリデーション */
    validation: function() {
      var v = {
        shop_id: !!this.plan.shop_id,
        plan_date: !!this.plan.plan_date,
        creator_id: !!this.plan.creator_id,
        patient_name: !!this.plan.patient_name,
        sex: this.plan.sex == 0 || this.plan.sex == 1 ? true : false,
        birthday: !!this.plan.birthday,
        clinic_id: !!this.plan.clinic_id,
        doctor_id: !!this.plan.doctor_id,
        careman_id: !this.plan.careoffice_id || !!this.plan.careman_id,
        facility_id: !!this.plan.facility_id,
        tel_requird: !!this.plan.tel,
        tel_pattern: !this.plan.tel || utils.regex.tel.test(this.plan.tel),
        post_no_requird: !!this.plan.post_no,
        post_no_pattern: !this.plan.post_no || utils.regex.post_no.test(this.plan.post_no),
        address1: !!this.plan.address1,
        address2: !!this.plan.address2,
        emergency_tel_pattern: !this.plan.emergency_tel || utils.regex.tel.test(this.plan.emergency_tel),
        emergency2_tel_pattern: !this.plan.emergency2_tel || utils.regex.tel.test(this.plan.emergency2_tel),
        emergency_post_no_pattern: !this.plan.emergency_post_no || utils.regex.post_no.test(this.plan.emergency_post_no),
        visit_interval: !!this.plan.visit_interval,
        diseases: (this.plan.disease_ids.length > 0),
        patient_name_furigana: utils.isHiragana(this.plan.patient_name_furigana, false),
        // 改行
        visit_plan_format:      !utils.isLineFeedCountOver(this.plan.visit_plan,      constant.plan.textarea.visit_plan),      // 訪問計画
        body_character_format:  !utils.isLineFeedCountOver(this.plan.body_character,  constant.plan.textarea.body_character),  // 患者の心身の特性 注意すべき点
        complication_format:    !utils.isLineFeedCountOver(this.plan.complication,    constant.plan.textarea.complication),    // 合併症・既往歴
        special_comment_format: !utils.isLineFeedCountOver(this.plan.special_comment, constant.plan.textarea.special_comment), // 特記事項・調剤訪問における注意事項
        meeting_comment_format: !utils.isLineFeedCountOver(this.plan.meeting_comment, constant.plan.textarea.meeting_comment)  // 担当者会議出席記録
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    /** apiローディング */
    loading () {
      return this.$store.getters.apiLoading
    },
    nsPatient () {
      return this.$store.getters.ns_patient
    },
    outPatient () {
      return this.$store.getters.outpatient
    }
  },

  methods: {
    /** 計画書 */
    showPlan: function (plan_id = null, patient_id = null) {
      this.searchCallbackFlag = false
      this.$store.dispatch('PLAN_GET', {
        data: {plan_id: plan_id, patient_id: patient_id},
        callback: this.onGetPlan
      })
    },
    showOutpatient: function (outpatientId) {
      // 外来患者検索
      var data = {}
      var self = this
      var callback = function (data) {

        if (self.isAdminOrPharmacist) {
          self.plan.creator_id    = self.userAdminOrPharmacistId
          self.plan.creator_name  = self.userAdminOrPharmacistName
          self.ac.creator_name    = self.userAdminOrPharmacistName
        }
        self.plan.shop_id = self.outPatient.attributes['shop-id']
        self.plan.patient_name = self.outPatient.attributes['outpatient-name']
        self.plan.patient_name_furigana = self.outPatient.attributes['outpatient-name-furigana']
        self.plan.sex = self.outPatient.attributes['sex-value']
        self.plan.birthday = self.outPatient.attributes['birthday-value']
        // self.plan.patient_code = self.outPatient.attributes['patient-code']
        self.plan.ns_patient_code = self.outPatient.attributes['patient-code']
      }
      this.$store.dispatch('OUTPATIENT_SEARCH_DETAIL', {
        outpatientId: this.$route.params.outpatientId, data: data , callback: callback
      })
    },
    onGetPlan: function (plan) {
      for(var key in this.plan){
        this.plan[key] = plan[key];
      }
      this.ac.facility_name = this.plan.facility_name
      this.ac.creator_name = this.plan.creator_name
      this.ac.clinic_name = this.plan.clinic_name
      this.ac.doctor_name = this.plan.doctor_name
      this.ac.careoffice_name = this.plan.careoffice_name
      this.ac.careman_name = this.plan.careman_name

      this.planBackup = utils.clone(this.plan)
      this.searchCallbackFlag = true
    },

    /** 店舗 */
    onChangeShop: function () {
      // 店舗の変更時、作成者をクリア
      this.plan.creator_id = null
      this.plan.creator_name = null
      this.ac.creator_name = null
    },

    /** 郵便番号 */
    onChangePostNo: function () {
      if (!!this.plan.post_no && utils.regex.post_no.test(this.plan.post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.plan.post_no, callback: (addr) => {
            if (addr) {
              this.plan.address1 = addr.address1
              this.plan.address2 = addr.address2
            }
          }
        })
      }
    },
    onChangeEmergencyPostNo: function () {
      if (!!this.plan.emergency_post_no && utils.regex.post_no.test(this.plan.emergency_post_no)) {
        this.$store.dispatch('ADDRESS_GET', {
          postal_code: this.plan.emergency_post_no, callback: (addr) => {
            if (addr) {
              this.plan.emergency_address1 = addr.address1
              this.plan.emergency_address2 = addr.address2
            }
          }
        })
      }
    },

    /** 作成者 */
    getCreators: function () {
      // 管理者 薬剤師のみ選択可能
      this.$store.dispatch('USER_SEARCH', {
        data: {
          shop_id: this.plan.shop_id,
          user_authority_or_pharmacist_flag: 1,
          user_name: this.plan.creator_name,
          all_get: true,
        },
        loadparams: false,
        autocomplete: true, noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearCreators: function () {
      if (this.ac.creator_name !== this.plan.creator_name) {
        this.plan.creator_name = this.ac.creator_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.showValidate.creator_id = true
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR')
    },
    setSearchCreator: function (id, name) {
      var nm = this.trim(name)
      this.plan.creator_id = id
      this.plan.creator_name = nm
      this.ac.creator_name = nm
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR')
    },

    /** 施設 */
    getFacilities: function () {
      this.$store.dispatch('FACILITY_SEARCH', {
        data: {
          'facility_name': this.trim(this.plan.facility_name),
          'shop_id': this.plan.shop_id,
          'all_get': true,
        },
        autocomplete: true
      })
    },
    clearFacilities: function () {
      if (this.ac.facility_name !== this.plan.facility_name) {
        this.plan.facility_name = this.ac.facility_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.showValidate.facility_id = true
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR')
    },
    setSearchFacility: function (id, name) {
      var nm = this.trim(name)
      this.plan.facility_id = id
      this.plan.facility_name = nm
      this.ac.facility_name = nm

      for (var o of this.facilities) {
        if (utils.str2int(o.id) === utils.str2int(id)) {
          this.plan.tel = o.attributes['tel']
          this.plan.post_no = o.attributes['post-no']
          this.plan.address1 = o.attributes['address1']
          this.plan.address2 = o.attributes['address2']
          break
        }
      }
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR')
    },

    /** 医療機関 */
    getClinics: function () {
      this.$store.dispatch('CLINIC_SEARCH', {
        data: {
          'clinic_name': this.trim(this.plan.clinic_name),
          'shop_id': this.plan.shop_id,
          'all_get': true,
        },
        autocomplete: true,
        noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearClinics: function () {
      if (this.ac.clinic_name !== this.plan.clinic_name) {
        this.plan.clinic_name = this.ac.clinic_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.showValidate.clinic_id = true
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR')
    },
    setSearchClinic: function (id, name) {
      var nm = this.trim(name)
      this.plan.clinic_name = nm
      this.ac.clinic_name = nm
      if (this.plan.clinic_id != id) {
        this.plan.clinic_id = id

        // 医療機関の変更時、主治医をクリア
        this.plan.doctor_id = null
        this.plan.doctor_name = null
        this.ac.doctor_name = null
      }
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR')
    },

    /** 医師 */
    getDoctors: function () {
      if (this.plan.clinic_id) {
        this.$store.dispatch('DOCTOR_SEARCH', {
          data: {
            shop_id: this.plan.shop_id,
            clinic_id: this.plan.clinic_id,
            doctor_name: this.trim(this.plan.doctor_name),
            all_get: true,
          },
          autocomplete: true,
          noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
        })
      }
    },
    clearDoctors: function () {
      if (this.ac.doctor_name !== this.plan.doctor_name) {
        this.plan.doctor_name = this.ac.doctor_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.showValidate.doctor_id = true
      this.$store.dispatch('DOCTOR_AUTOCOMPLETE_CLEAR')
    },
    setSearchDoctor: function (id, name) {
      var nm = this.trim(name)
      this.plan.doctor_id = id
      this.plan.doctor_name = nm
      this.ac.doctor_name = nm
      this.$store.dispatch('DOCTOR_AUTOCOMPLETE_CLEAR')
    },

    /** ケアオフィス */
    getCareOffices: function () {
      this.plan.care_office_id = null
      this.$store.dispatch('CARE_OFFICE_SEARCH', {
        data: {
          'careoffice_name': this.trim(this.plan.careoffice_name),
          'shop_id': this.plan.shop_id,
          'all_get': true,
        },
        autocomplete: true,
        noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
      })
    },
    clearCareOffices: function () {
      if (this.ac.careoffice_name !== this.plan.careoffice_name) {
        this.plan.careoffice_name = this.ac.careoffice_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.showValidate.careman_id = true
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR')
    },
    setSearchCareOffice: function (id, name) {
      var nm = this.trim(name)
      this.plan.careoffice_name = nm
      this.ac.careoffice_name = nm
      if (this.plan.careoffice_id != id) {
        this.plan.careoffice_id = id

        // 支援事業所の変更時、ケアマネをクリア
        this.plan.careman_id = null
        this.plan.careman_name = null
        this.ac.careman_name = null
      }
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR')
    },

    /** ケアマネ */
    getCaremans: function () {
      if (this.plan.careoffice_id) {
        this.$store.dispatch('CAREMAN_SEARCH', {
          data: {
            shop_id: this.plan.shop_id,
            careoffice_id: this.plan.careoffice_id,
            careman_name: this.trim(this.plan.careman_name),
            all_get: true,
          },
          autocomplete: true,
          noneList: {id: this.$t('none_list.id'), name: this.$t('none_list.name')}
        })
      }
    },
    clearCaremans: function () {
      if (this.ac.careman_name !== this.plan.careman_name) {
        this.plan.careman_name = this.ac.careman_name
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'messages.select_list_item', danger: true })
      }
      this.$store.dispatch('CAREMAN_AUTOCOMPLETE_CLEAR')
    },
    setSearchCareman: function (id, name) {
      var nm = this.trim(name)
      this.plan.careman_id = id
      this.plan.careman_name = nm
      this.ac.careman_name = nm
      this.$store.dispatch('CAREMAN_AUTOCOMPLETE_CLEAR')
    },

    /** 副作用歴 */
    getSideEffectHistories: function() {
      this.enableList.sideEffectHistories = !this.enableList.sideEffectHistories
      this.$refs.side_effect_history_autocomplete.focus()
    },
    setSideEffectHistories: function(id, val) {
      if (!!val && this.plan.side_effect_history !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.SIDE_EFFECT_HISTORY, phrase: val}})
      }
      this.plan.side_effect_history = val
      this.enableList.sideEffectHistories = false
    },

    /** アレルギー歴 */
    getAllergyHistories: function() {
      this.enableList.allergyHistories = !this.enableList.allergyHistories
      this.$refs.allergy_history_autocomplete.focus()
    },
    setAllergyHistories: function(id, val) {
      if (!!val && this.plan.allergy_history !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.ALLERGY_HISTORY, phrase: val}})
      }
      this.plan.allergy_history = val
      this.enableList.allergyHistories = false
    },

    /** 緊急連絡先 */
    getEmergencyRels: function() {
      this.enableList.emergencyRels = !this.enableList.emergencyRels
      this.$refs.emergency_rels_autocomplete.focus()
    },
    setEmergencyRels: function(id, val) {
      if (!!val && this.plan.emergency_rel !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.EMERGENCY_REL, phrase: val}})
      }
      this.plan.emergency_rel = val
      this.enableList.emergencyRels = false
    },

    /** 緊急連絡先２ */
    getEmergency2Rels: function() {
      this.enableList.emergency2Rels = !this.enableList.emergency2Rels
      this.$refs.emergency2_rels_autocomplete.focus()
    },
    setEmergency2Rels: function(id, val) {
      if (!!val && this.plan.emergency2_rel !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.EMERGENCY_REL, phrase: val}})
      }
      this.plan.emergency2_rel = val
      this.enableList.emergency2Rels = false
    },

    /** 患者の心身の特性 */
    getBodyCharacters: function() {
      this.enableList.bodyCharacters = !this.enableList.bodyCharacters
      this.$refs.body_character_autocomplete.focus()
    },
    setBodyCharacters: function(id, val) {
      if (!!val && this.plan.body_character !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.BODY_CHARACTER, phrase: val}})
      }
      this.plan.body_character = (!!this.plan.body_character ? this.plan.body_character : "") + val
      this.enableList.bodyCharacters = false
    },

    /** 合併症・既往歴 */
    getComplications: function() {
      this.enableList.complications = !this.enableList.complications
      this.$refs.complication_autocomplete.focus()
    },
    setComplications: function(id, val) {
      if (!!val && this.plan.complication !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.COMPLICATION, phrase: val}})
      }
      this.plan.complication = (!!this.plan.complication ? this.plan.complication : "") + val
      this.enableList.complications = false
    },

    /** 服薬支援 */
    getLeadPlans1: function() {
      this.enableList.leadPlans1 = !this.enableList.leadPlans1
      this.$refs.lead_plan1_autocomplete.focus()
    },
    setLeadPlans1: function(id, val) {
      if (!!val && this.plan.lead_plan1 !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.LEAD_PLAN, phrase: val}})
      }
      this.plan.lead_plan1 = val
      this.enableList.leadPlans1 = false
    },

    getLeadPlans2: function() {
      this.enableList.leadPlans2 = !this.enableList.leadPlans2
      this.$refs.lead_plan2_autocomplete.focus()
    },
    setLeadPlans2: function(id, val) {
      if (!!val && this.plan.lead_plan2 !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.LEAD_PLAN, phrase: val}})
      }
      this.plan.lead_plan2 = val
      this.enableList.leadPlans2 = false
    },

    getLeadPlans3: function() {
      this.enableList.leadPlans3 = !this.enableList.leadPlans3
      this.$refs.lead_plan3_autocomplete.focus()
    },
    setLeadPlans3: function(id, val) {
      if (!!val && this.plan.lead_plan3 !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.LEAD_PLAN, phrase: val}})
      }
      this.plan.lead_plan3 = val
      this.enableList.leadPlans3 = false
    },

    getLeadPlans4: function() {
      this.enableList.leadPlans4 = !this.enableList.leadPlans4
      this.$refs.lead_plan4_autocomplete.focus()
    },
    setLeadPlans4: function(id, val) {
      if (!!val && this.plan.lead_plan4 !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.LEAD_PLAN, phrase: val}})
      }
      this.plan.lead_plan4 = val
      this.enableList.leadPlans4 = false
    },

    getLeadPlans5: function() {
      this.enableList.leadPlans5 = !this.enableList.leadPlans5
      this.$refs.lead_plan5_autocomplete.focus()
    },
    setLeadPlans5: function(id, val) {
      if (!!val && this.plan.lead_plan5 !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.LEAD_PLAN, phrase: val}})
      }
      this.plan.lead_plan5 = val
      this.enableList.leadPlans5 = false
    },

    getLeadPlans6: function() {
      this.enableList.leadPlans6 = !this.enableList.leadPlans6
      this.$refs.lead_plan6_autocomplete.focus()
    },
    setLeadPlans6: function(id, val) {
      if (!!val && this.plan.lead_plan6 !== val) {
        this.$store.dispatch('PHRASE_USE', {data: {phrase_type: constant.phraseType.LEAD_PLAN, phrase: val}})
      }
      this.plan.lead_plan6 = val
      this.enableList.leadPlans6 = false
    },

    /** 患者写真 */
    onDragOver: function (event) {
      console.log('onDragOver')
      event.preventDefault()
    },
    onDrop: function (event) {
      console.log('onDrop')
      // ブラウザ上でファイルを展開する挙動を抑止
      event.preventDefault()

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.dataTransfer.files
      this.upload(files)
    },
    onFileChange: function (event) {
      console.log('onFileChange')

      // ドロップされたファイルのfilesプロパティを参照
      var files = event.target.files
      this.upload(files)
    },
    uploadStart (patientId) {
      this.$store.dispatch('PATIENT_UPLOAD_START')
    },
    upload: function (files) {
      // 一件アップロード
      var formData = new FormData()
      formData.append('patient[avartar]', files[0])
      this.$store.dispatch('PATIENT_AVATAR_UPLOAD', { data: formData, callback: this.onUpload })
    },
    onUpload: function (data) {
      this.plan.patient_avartar = data.avartar
      this.plan.patient_avartar_cache = data.avartar_cache
      this.plan.patient_avartar_cache_path = data.image_path
    },

    /** 保存ボタン押下 */
    onClickSave: function () {
      this.canValidate = true
      if (this.isValid) {
        if (this.isDetailFlag) {
          if (this.isTypeFlag){
            // 月中での計画書変更のときplan_idを削除し、新規保存
            this.plan.plan_id = null
            this.$store.dispatch('PLAN_COPY_EDIT', { data: this.plan, callback: this.planCopyEdit })
          }else {
            this.$store.dispatch('PLAN_SAVE', { data: this.plan, callback: this.onSaved })
          }
        }else{
          this.confirmYesNo = true
          this.$store.dispatch('PLAN_SAVE', { data: this.plan, callback: this.planNextMonthCheck })
        }
      }else{
        this.$store.dispatch('PLAN_MSG_ALERT', { message_i18n: 'plan.validate_error_message', danger: true })
      }
    },
    onSaved: function (result) {
      this.goBack()
    },

    planCopyEdit(data){
      this.$store.dispatch(
        'PLAN_SAVE',
        { data: this.plan, callback: this.goPatientsPlan }
      )
    },

    /** 翌月分作成用日付チェック */
    planNextMonthCheck (data) {
        this.$store.dispatch(
          'PLAN_NEXT_MONTH_CHECK',
          { data: {plan_id: data}, callback: this.next_plan_edit }
        )
    },
    /** 翌月分作成用ダイアログ */
    next_plan_edit (data) {
      var save = () => {
      this.$store.dispatch(
        'PLAN_EDIT_NEXT_MONTH',
        { data: {plan_id: data.plan_id}, callback: this.planNextMonthCheck })
      }
      if (data.edit_month != null) {
        // 確認ダイアログ設定+表示
        var year = data.edit_month.toString().substr(0,4)
        var month= data.edit_month.toString().substr(4,2)
        this.confirmMessage = this.$t('plan.next_plan_confirm_message', {'year': year, 'month': month})
        this.confirmOnYes = save
        this.confirmOnNo = () => { this.goBack() }
        this.$refs.confirmBtn.click()
      } else {
        this.goBack()
      }
    },
    /** キャンセルボタン押下 */
    onClickCancel: function () {
      // ダーティチェック
      if (utils.checkObjDiff(this.plan, this.planBackup)) {
        // ダーティなら確認ダイアログ設定＋表示
        this.confirmMessage = this.$t('plan.cancel_edit_message')
        this.confirmOnSave = () => { this.onClickSave() }
        this.confirmOnNotSave = () => { this.goBack() }
        this.confirmOnCancel = () => { }
        this.$refs.confirmBtn.click()
      } else {
        this.goBack()
      }
    },

    /** 患者検索に戻る */
    goPatientsList: function () {
      this.$router.push({ path: '/patients/list/', query: {'keep': 'true'}})
    },
    /** 計画書検索ページに戻る 削除の場合キープせずに再検索 */
    goPatientsPlan: function () {
      this.$router.push({ path: '/patients/plan/' + this.$route.params.facilityId + '/' + this.$route.params.patientId, query: {'keep': 'true'}})
    },
    /** 前ページに戻る */
    goBack: function () {
      if ('facilityId' in this.$route.params && 'patientId' in this.$route.params && 'planId' in this.$route.params) {
        this.$router.push({ path: '/plans/detail/' + this.$route.params.facilityId + '/' + this.$route.params.patientId + '/' + this.$route.params.planId})
      } else if (this.$router.currentRoute.query.from === 'list') {
        this.$router.push({ path: '/patients/list', query: {'keep': 'true'}})
      } else if (this.isOutpatientFlag) {
        this.$router.push({ path: '/outpatients/detail/' + this.$route.params.outpatientId, query: { type: this.$router.currentRoute.query.type } })
      } else if(this.$router.currentRoute.query.nsips == 'patient'){
        this.$router.push({ path: '/nsips/patients/list'})
      }
      else {
        this.$router.push({ path: '/'})
      }
    },
    /** 外来患者詳細に戻る */
    goOutpatientDetail: function () {
      this.$router.push({ path: '/outpatients/detail/' + this.$route.params.outpatientId, query: { type: this.$router.currentRoute.query.type } })
    },
    /** 外来患者検索に戻る */
    goOutpatientList: function () {
      this.$router.push({ path: '/outpatients/list', query: { type: this.$router.currentRoute.query.type } })
    },
    
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = (!!this.plan.patient_avartar_cache_path ? this.plan.patient_avartar_cache_path : this.plan.patient_avartar) + '?token=' + this.authToken
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    },

    /** 全リストデータをクリア */
    clearAllList: function () {
      this.$store.dispatch('USER_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('FACILITY_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CLINIC_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('DOCTOR_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CARE_OFFICE_AUTOCOMPLETE_CLEAR', 0)
      this.$store.dispatch('CAREMAN_AUTOCOMPLETE_CLEAR', 0)
      Object.keys(this.enableList).forEach(key => { this.enableList[key] = false })
    },
    clearPhraseList: function() {
      this.lazyExec(() => {
        Object.keys(this.enableList).forEach(key => { this.enableList[key] = false })
      })
    },
    lazyExec: function (func) {
      // setTimeout(func}, utils.key_delay)
      this.$nextTick(func)
    },

    /** 手入力値から、なし/全て を除外 */
    trim: function (name) {
      if (!name) return ''
      if (name.trim() == this.$t('none_list.name')) return ''
      return name.trim()
    },

    /** 日付 (和暦) 用 */
    getWareki: function (seireki_str) {
      if ((!seireki_str) || isNaN(Date.parse(seireki_str))) {
        return ''
      } else {
        return utils.sereki2Wareki(this.$t, new Date(Date.parse(seireki_str)))
      }
    },
    getSeireki: function (wareki_str) {
      return utils.wareki2Seireki(this.$t, wareki_str, 'y-m-d')
    },
    getHHMM: function (seireki_str) {
      var d = new Date(Date.parse(seireki_str))
      return ("0"+d.getHours()).slice(-2) + ":" + ("0"+d.getMinutes()).slice(-2)
    },

  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/plan-edit.js